import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Autocomplete,
  Button,
  Stack,
  TextField,
  Typography
} from '@mui/material';

import type { EPUserPickerProps } from './EscalationProfile.types';

const EPUserPicker = ({
  options,
  value,
  onChange,
  getOptionDisabled,
  renderOptionSubtitle,
  onAdd
}: EPUserPickerProps) => (
  <Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
    <Autocomplete
      value={value}
      onChange={(_, val) => onChange(val)}
      options={options}
      getOptionLabel={(u) => u.name}
      getOptionDisabled={getOptionDisabled}
      renderOption={(props, u) => (
        <li {...props}>
          <Stack>
            <Typography variant="body2">{u.name}</Typography>
            {renderOptionSubtitle(u)}
          </Stack>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          placeholder="Add User"
          variant="outlined"
        />
      )}
      sx={{ minWidth: '14rem' }}
      size="small"
    />
    <Button
      variant="outlined"
      onClick={onAdd}
      disabled={!value}
      startIcon={<FontAwesomeIcon icon={faPlus} />}
    >
      Add
    </Button>
  </Stack>
);

export default EPUserPicker;
